export default "__VITE_ASSET__CmBy1KXs__"